<template>
  <v-layout>
    <v-flex xs12>
      <v-expansion-panel popout>
        <v-category v-for="(category, index) in categories" :key="index" :category="category" />
      </v-expansion-panel>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";

import VCategory from "../../../../components/Category";

export default {
  components: {
    VCategory
  },
  computed: {
    ...mapState("classifier", ["categories"])
  }
};
</script>